<script>
export default {
    name: "IconPaymentMasterCard"
}
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="30px" height="30px" viewBox="750 0 160 120">
        <path d="M830.966 33.2714H801.224V86.7256H830.966V33.2714Z" fill="#FF5F00"/>
        <path d="M803.017 60C803.017 49.1387 808.115 39.5054 815.952 33.2724C810.193 28.7389 802.922 26 794.991 26C776.202 26 761 41.2055 761 60C761 78.7945 776.202 94 794.991 94C802.922 94 810.193 91.2613 815.952 86.7277C808.115 80.5888 803.017 70.8608 803.017 60Z" fill="#EB001B"/>
        <path d="M871 60C871 78.7945 855.798 94 837.009 94C829.078 94 821.807 91.2613 816.048 86.7277C823.979 80.4941 828.983 70.8608 828.983 60C828.983 49.1387 823.885 39.5054 816.048 33.2724C821.807 28.7389 829.078 26 837.009 26C855.798 26 871 41.3002 871 60Z" fill="#F79E1B"/>
    </svg>
</template>

<style scoped lang="scss">

</style>
